export default __webpack_public_path__ + "static/media/tl8.150cd491.webp";